export const amchartsSetAriaLabel = (elementOrSelector, label) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    console.warn(
      `[amchartsSetAriaLabel]: Attempted to set aria-label "${label}" on "${elementOrSelector}" during SSR. Ignoring.`
    )
    return
  }

  let element

  if (typeof elementOrSelector === 'string') {
    if (!elementOrSelector.startsWith('#')) {
      elementOrSelector = `#${elementOrSelector}`
    }

    element = document.querySelector(elementOrSelector)
    if (!element) {
      console.error(
        `[amchartsSetAriaLabel]: Element not found for selector: ${elementOrSelector}`
      )
      return
    }
  } else if (elementOrSelector instanceof HTMLElement) {
    element = elementOrSelector
  } else {
    console.error(
      '[amchartsSetAriaLabel]: Invalid input. Provide a string selector or an HTMLElement.'
    )
    return
  }

  element.setAttribute('aria-label', label)
}
